import Vue from 'vue'
import Router from '../../router' 
// import Store from '../../store' 
// import VueRouter from 'vue-router'
import bhUi from '../../components/bh-ui'
const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

const common = {
  // return {
  isIos: isIos,
  validateForm(data, rules) {
    return new Promise((resolve) => {
      let endValidata = false
      for (let i in rules) {
        rules[i].forEach(item => {
          if (!item.validate(data[i])) {
            bhUi.Toast({
              text: item.message
            })
            // console.log(item.message)
            endValidata = true
            return false
          }
        })
        if (endValidata) {
          break
        }
      }
      console.log(endValidata)
      if (!endValidata) {
        resolve()
      }
    })
  },
  deepClone(obj, cache = []) { // 深拷贝对象
    if (obj === null || typeof obj !== 'object') {
      return obj
    }
    const hit = cache.filter(c => c.original === obj)[0]
    if (hit) {
      return hit.copy
    }
    const copy = Array.isArray(obj) ? [] : {}
    cache.push({
      original: obj,
      copy
    })
    Object.keys(obj).forEach(key => {
      copy[key] = common.deepClone(obj[key], cache)
    })
    return copy
  },
  routerBack() {
    Router.back()
    //   Store.commit('setPageDirection', 'slide-right')
    // setTimeout(() => {
    //   Router.back()
    // }, 0)
  },
  routerPush(data){
    // Store.commit('setPageDirection', 'slide-left')
    // setTimeout(() => {
    Router.push(data)
    // }, 0)
    // if (typeof data === 'string') {

    // } else {
    //   setTimeout(() => {
    //     Router.push(data)
    //   }, 0)
    // }
  },
  install() {
    // console.log(common())
    Vue.prototype.$common = common
  }
  // }
}

// window.native = native

export default common